import styled from "styled-components";
import {hexToRgba} from "../../../../themes/hex-to-rgba";
import {FadeWrapper} from "../../fade-in-div-on-mount.component";

export const MaskFabricBox = styled(FadeWrapper)`
	width: 100%;
    height: 100%;
    background-color: ${({theme}) => hexToRgba(theme.colors.backgroundDark, 0.9)};
    background: linear-gradient(${({theme}) => hexToRgba(theme.colors.backgroundDark, 0.9)} 0%, ${({theme}) => theme.colors.backgroundDark} 92%, ${({theme}) => theme.colors.backgroundDark} 100%);
`;